// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/202606220013/js/" + chunkId + "." + {"44":"6a28b191","225":"baca1c27","481":"61ea5d24","486":"4da63909","770":"7e368b45"}[chunkId] + ".0.2138091354002627.chunk.js";
};